export default "__VITE_ASSET__snmNIvho__"